module.exports = __webpack_public_path__ + "static/media/paypal.7d02f920.svg";